import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en';
import ja from './locales/ja';
import zhTW from './locales/zh-TW';
import { resolveInitialLanguage } from './initial-language';
import { isLikelySignedIn, readLangCookie } from './shared-lang-cookie';

const STORAGE_KEY = 'stitchpress-i18n-lang';

function getInitialLanguage(): string {
    const { lang, persist } = resolveInitialLanguage({
        // A `?lang=` query param (e.g. a deep link from the marketing site) wins so a
        // visitor's language carries across the subdomain boundary that localStorage
        // can't. It persists to localStorage but deliberately does NOT write the
        // shared cookie — following a shared link must not flip the recipient's
        // cross-site preference.
        queryLang: new URLSearchParams(window.location.search).get('lang'),
        cookieLang: readLangCookie(document.cookie, window.location.hostname),
        likelySignedIn: isLikelySignedIn(document.cookie),
        storedLang: localStorage.getItem(STORAGE_KEY),
        browserLang: navigator.language,
    });
    if (persist) persistLanguage(lang);
    return lang;
}

i18n.use(initReactI18next).init({
    resources: {
        en,
        'zh-TW': zhTW,
        ja,
    },
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
});

/**
 * Persist the chosen language so it survives reloads.
 *
 * Persistence is intentionally NOT wired to i18next's `languageChanged` event:
 * the settings page changes the language live as a *preview* and only commits on
 * Apply. Auto-persisting every change would make an unapplied preview survive a
 * page reload. Call this only on an explicit commit (Apply, or a standalone
 * instant switcher).
 */
export function persistLanguage(lng: string): void {
    localStorage.setItem(STORAGE_KEY, lng);
}

export default i18n;
